import { LoginDesktopView } from './LoginDesktopView';
import type { LoginProps } from '../pages/LoginPage';

export function LoginMobileView(props: LoginProps) {
  return <LoginDesktopView {...props} variant="mobile" />;
}
